import curry from "ramda/es/curry";
const defaultAutocompleteOption = (freeSolo, valuePropName = 'code', labelPropName = 'name')=>(option)=>freeSolo ? option.label ?? option[valuePropName] : {
            value: option[valuePropName],
            label: option[labelPropName]
        };
export const defaultAutocompleteCreateOptions = curry((freeSolo, filterFn, options)=>options.filter(filterFn).map(defaultAutocompleteOption(freeSolo)));
export const defaultObjectCreateOptions = ({ freeSolo, optionsFilter, valuePropName, labelPropName, options })=>options.filter(optionsFilter).map(defaultAutocompleteOption(freeSolo, valuePropName, labelPropName));
